<div class="t-widget--noPadding">
  <header class="l-flex-column l-align-top summary-box-header">
    <h2 class="t-widgetTitle">
      {{ "translate.dashboard.tasksTitle" | translate }}
    </h2>
    <hr />
  </header>

  <!--my tasks-->
  <div
    class="summary-row no-border"
    [class.allow-hover]="data.myTasksCnt > 0"
    (click)="data.myTasksCnt > 0 ? filterOrdersByChatCode('MY_TASKS') : null"
  >
    <p class="lbl colored">
      {{ "translate.dashboard.myTasks" | translate }}
    </p>
    <p class="value">{{ data.myTasksCnt }}</p>
  </div>

  <!-- late tasks -->
  <div
    class="summary-row no-border"
    [class.allow-hover]="data.lateTasksCnt > 0"
    (click)="
      data.lateTasksCnt > 0 ? filterOrdersByChatCode('LATE_TASKS') : null
    "
  >
    <p class="lbl colored">
      {{ "translate.dashboard.lateTasks" | translate }}
    </p>
    <p class="value">{{ data.lateTasksCnt }}</p>
  </div>

  <!-- clinic delays -->
  <div
    *ngIf="displayClinicDelays"
    class="summary-row no-border"
    [class.allow-hover]="data.clinicDelayAlertCnt > 0"
    (click)="
      data.clinicDelayAlertCnt > 0
        ? filterOrdersByChatCode('DELAY_EMAILS')
        : null
    "
  >
    <p class="lbl colored">
      {{ "translate.dashboard.clinicDelays" | translate }}
    </p>
    <p class="value">{{ data.clinicDelayAlertCnt }}</p>
  </div>

  <!-- all open tasks -->
  <div
    class="summary-row no-border"
    [class.allow-hover]="data.allOpenTasksCnt > 0"
    (click)="
      data.allOpenTasksCnt > 0 ? filterOrdersByChatCode('ALL_OPEN_TASKS') : null
    "
  >
    <p class="lbl colored">
      {{ "translate.dashboard.allOpenTasks" | translate }}
    </p>
    <p class="value">{{ data.allOpenTasksCnt }}</p>
  </div>

  <!-- all closed tasks -->
  <div
    class="summary-row no-border"
    [class.allow-hover]="data.allClosedTasksCnt > 0"
    (click)="
      data.allClosedTasksCnt > 0
        ? filterOrdersByChatCode('ALL_CLOSED_TASKS')
        : null
    "
  >
    <p class="lbl colored">
      {{ "translate.dashboard.allClosedTasks" | translate }}
    </p>
    <p class="value">{{ data.allClosedTasksCnt }}</p>
  </div>
</div>
